(function () {
  const listMenus = document.querySelectorAll('.menu_left_block.custom .list-menu-item.list-menu--submenu');

  if (listMenus.length) {
    listMenus.forEach((menu) => {
      // menu.addEventListener("mouseover", function() {
        
      // })
      const submenu = menu.querySelector('.header__submenu.list-menu.list-menu--disclosure');

      // Sự kiện toggle submenu cấp 1
      menu.addEventListener('mouseover', function (e) {


        // Toggle submenu cấp 1
        submenu.classList.add('active');
      });
      menu.addEventListener('mouseleave', function (e) {
        submenu.classList.remove('active');
      });

      // Tìm tất cả link cấp 2
      const linkLists = menu.querySelectorAll('li:not(.list-menu--submenu) > .header__menu-item.list-menu__item.link');
      if (linkLists.length) {
        linkLists.forEach((link) => {
          const submenu2 = link.parentElement.querySelector('.header__submenu');
          if (submenu2) {
            link.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation(); // 🟢 rất quan trọng — ngăn sự kiện lan lên menu cha

              // Nếu click bên trong submenu thì không đóng
              if (submenu2 && submenu2.contains(e.target)) return;

              submenu2.classList.toggle('active');
              link.classList.toggle('header__menu-item--active');
            });
          }
        });
      }
    });
  }
})();
(function () {
	const listMenus = document.querySelectorAll('.custom-details .menu-drawer__menu-item.custom-summary');

	if (listMenus.length) {
		listMenus.forEach((menu) => {
			// const submenu = menu.querySelector('.header__submenu.list-menu.list-menu--disclosure');

			// Sự kiện toggle submenu cấp 1
      const icon = menu.querySelector('.icon-custom');
			icon.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation(); // 🟢 rất quan trọng — ngăn sự kiện lan lên menu cha
        const parent = menu.closest('.menu-drawer__menu');
        const lists = parent.querySelectorAll('li > .custom-details');
        lists.forEach((item) => {
          if(item != menu.parentElement)
          item.classList.remove('active');
        });
				menu.parentElement.classList.toggle('active');
			});

			// Tìm tất cả link cấp 2
			// const linkLists = menu.querySelectorAll('li > .header__menu-item.list-menu__item.link');
			// if (linkLists.length) {
			//   linkLists.forEach((link) => {
			//     const submenu2 = link.parentElement.querySelector('.header__submenu');
			//     if (submenu2) {
			//       link.addEventListener('click', function (e) {
			//         e.preventDefault();
			//         e.stopPropagation(); // 🟢 rất quan trọng — ngăn sự kiện lan lên menu cha

			//         // Nếu click bên trong submenu thì không đóng
			//         if (submenu2 && submenu2.contains(e.target)) return;

			//         submenu2.classList.toggle('active');
			//         link.classList.toggle('header__menu-item--active');
			//       });
			//     }
			//   });
			// }
		});
	}
})();




